import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared';
import { RepresentanteSharedModule } from './representante-shared.module';
import { RepresentantePipeSharedModule } from './pipes';
import { RepresentanteFilterModule } from './filter';
import { PessoaSharedModule } from '../pessoa-shared.module';
import { RepresentanteClassificacaoClienteFormModule } from './classificacao-cliente';
import { UsuarioSharedModule } from '../../usuario/usuario-shared.module';
import { CidadeModule } from '../../cidade';
import { IntegrationRepresentanteSharedModule } from '../../configuracoes/integration/representante';
import { FileUploadModule } from 'ng2-file-upload';
import { RepresentanteRoutingModule } from './representante-routing.module';
import { RepresentanteListModule } from './list';
import { RepresentanteDashboardModule } from './dashboard';
import { RepresentanteComponent } from './representante.component';
import { RepresentanteFormComponent} from './form';
import { RepresentanteImportModalComponent } from './import-modal';
import { RepresentanteMarcaComponent } from './marca';
import { RepresentanteLinhaComponent } from './linha';
import { RepresentanteVinculadoComponent } from './vinculado';
import { RepresentanteGerenteComponent } from './gerente';
import { RepresentanteAtendenteComponent } from './atendente';
import { RepresentanteConfiguracaoComponent, RepresentanteConfiguracaoMetaComponent } from './configuracao';
import { RepresentanteModalidadeComercialSelectModule } from './components/modalidade-comercial/select';

@NgModule({
    imports: [
        SharedModule,
        RepresentanteRoutingModule,
        RepresentanteSharedModule,
        RepresentantePipeSharedModule,
        RepresentanteFilterModule,
        RepresentanteListModule,
        RepresentanteDashboardModule,
        PessoaSharedModule,
        RepresentanteClassificacaoClienteFormModule,
        UsuarioSharedModule,
        CidadeModule,
        IntegrationRepresentanteSharedModule,
        FileUploadModule,
        RepresentanteModalidadeComercialSelectModule
    ],
    declarations: [
        RepresentanteComponent,
        RepresentanteFormComponent,
        RepresentanteImportModalComponent,
        RepresentanteMarcaComponent,
        RepresentanteLinhaComponent,
        RepresentanteVinculadoComponent,
        RepresentanteGerenteComponent,
        RepresentanteAtendenteComponent,
        RepresentanteConfiguracaoComponent,
        RepresentanteConfiguracaoMetaComponent
    ],
    exports: [
        RepresentanteSharedModule
    ]
})
export class RepresentanteModule { }
